




































import { defineComponent, onMounted, PropType } from '@vue/composition-api';
import ShowInfoItem from '@/components/show-info-item.vue';
import { GameFinanceModel } from './model';
import { useApolloModel } from 'vue-apollo-model';
import { handleErrorMessageToast } from '@/common/util';

export default defineComponent({
    components: {
        ShowInfoItem,
    },
    setup(props, context) {
        const model = useApolloModel(GameFinanceModel);
        function goProfile() {
            context.root.$router.push({
                path: '/platform/account',
            });
        }
        async function startConfirm() {
            const realynameUrl = await model.getRealynameUrl({
                appId: context.root.$route.params.appId,
                url: `${location.href}?from=auth`,
            });
            if (model.isPerExist) {
                context.emit('next-step');
                return;
            }
            if (realynameUrl) {
                window.location.href = realynameUrl;
                return;
            }
            handleErrorMessageToast(
                model.perRealynameUrlMutation.data.error_msg ||
                    '获取实名认证地址失败',
            );
        }
        onMounted(async () => {
            await model.getPerRealynameInfo({
                appId: context.root.$route.params.appId,
            });
        });
        return {
            model,
            goProfile,
            startConfirm,
        };
    },
});
